import styled from "styled-components";
import { colors } from "../../styles/variables.js";

export const NavContainer = styled.div`
   position: fixed;
   top: 50%;
   left: 10px;
   transform: translateY(-50%);
   z-index: 99;
   height: 13rem;
   padding: 0.4rem;

   @media (max-width: 800px) {
      display: none;
   }
`;

export const NavIcons = styled.div`
   display: flex;
   height: 100%;
   flex-direction: ${props => (props.row ? "row" : "column")};
   justify-content: ${props =>
      props.justify ? props.justify : "space-between"};
   align-items: center;
   font-size: ${props => (props.size ? props.size : "1.6rem")};

   color: ${colors.primary5};

   a {
      display: flex;
      justify-content: center;
      align-items: center;
      text-decoration: none;
      color: inherit;
   }

   svg {
      cursor: pointer;
      transition: color 0.1s ease-in-out;

      &:hover {
         color: ${colors.accent2};
      }
   }
`;
